import React from "react";
import { compose, lifecycle, withState, withProps, withHandlers } from "recompose";
import styled, { keyframes } from "styled-components";
import { StripeProvider, Elements } from "react-stripe-elements";
import updateTopNineOrder from "../../libs/updateTopNineOrder";
import StripeCheckoutHandler from "../common/Checkout/StripeCheckoutHandler";
import PaymentRequest from "../common/Checkout/PaymentRequest";
import Modal from "../common/Modal";
import { Button } from "../common/Button";
import SupportUs from "./SupportUs";
import RemoveWatermark from "./RemoveWatermark";

const PurchaseWatermarkContent = ({ open, onClose, ...props }) => (
  <Elements>
    <PaymentRequest onTokenSuccess={props.onTokenSuccess} amount={props.watermarkPrice}>
      {({ canMakePayment, showPaymentRequest }) => (
        <Container>
          <StripeCheckoutHandler amount={props.watermarkPrice} onTokenSuccess={props.onTokenSuccess}>
            {({ openStripe }) => (
              <SupportUs
                style={{ borderTop: "none", padding: 0, marginTop: 0 }}
                onClickIllustration={canMakePayment ? showPaymentRequest : openStripe}
                onClickText={canMakePayment ? showPaymentRequest : openStripe}
              />
            )}
          </StripeCheckoutHandler>
          <RemoveWatermark
            onClickBuy={canMakePayment ? showPaymentRequest : null}
            withBlueBackground
            showEmoji
            noShowInfo
            withSeparator
            canMakePayment={canMakePayment}
            onClose={onClose}
            {...props}
          />
        </Container>
      )}
    </PaymentRequest>
  </Elements>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 25px;
`;

const Text = styled.p`
  color: #6e788d;
  font-size: 15px !important;
  font-family: "Montserrat";
  font-weight: 500;
  text-align: left;
  @media (max-width: 640px) {
    font-size: 14px !important;
  }
  b {
    color: #f74255;
  }
`;

const PurchaseWatermarkModal = props => (
  <CustomModal {...props} darkCloseButton={true} onRequestClose={props.onClose}>
    <PurchaseWatermarkContent {...props} />
  </CustomModal>
);

const CustomModal = styled(Modal)`
  background-color: #ffffff;
  width: 80%;
  max-width: 340px;
`;

const enhancer = compose(
  withState("successModalOpen", "setSuccessModalOpen", false),
  withHandlers({
    onRequestClose: props => () => {
      props.setSuccessModalOpen(false);
    },
    onTokenSuccess: props => token => {
      if (props.onClose) {
        props.onClose();
      }
      updateTopNineOrder({
        stripe: {
          token: token.id,
        },
      })
        .then(() => {
          props.onStatusChange("success");
          props.refreshCurrentUser();
          props.setSuccessModalOpen(true);
        })
        .catch(() => {
          props.onStatusChange("error");
        });
    },
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      if (nextProps.open && !this.props.open) {
        if (window.gtag) {
          window.gtag("event", "page_view", { title: "Watermark Purchase Modal" });
        }
      }
    },
  })
);

export default enhancer(PurchaseWatermarkModal);
